import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { QBtn } from "quasar"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed, ref } from "vue"

interface Props {
  label: string
  isSelected?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFilterEntry',
  props: {
    label: {},
    isSelected: { type: Boolean, default: false }
  },
  emits: ["reset"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const btn = ref<QBtn | null>(null)

const isActive = computed<boolean>(() => {
  return props.isSelected && btn.value?.$props.disable !== true
})

const isInactive = computed<boolean>(() => {
  return !props.isSelected && btn.value?.$props.disable !== true
})

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    ref_key: "btn",
    ref: btn,
    clickable: "",
    class: _normalizeClass(["sfx-filter-entry-item bg-white q-pa-none q-pl-md", { 'active-item': isActive.value }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, {
            class: _normalizeClass(["text-h4", { 'inactive-label ': isInactive.value }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }),
      (isActive.value)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 0,
            avatar: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(QBtn), {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('reset')), ["stop"])),
                round: "",
                flat: "",
                "text-color": "white",
                icon: _unref(Icons).REJECT_CIRCLE
              }, null, 8, ["icon"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})